import { useEffect } from "react";

const PSIRRedirect = () => {
  useEffect(() => {
    window.location.replace(
      "https://instituteforhumanities.com/index.php/web/Exam_Prep/exam_detail/4612/PSIR%20-%20Postal%20Guidance%20Program%20(PGP)"
    );
  }, []);

  return null;
};

const GSFoundationOnlineCourseRedirect = () => {
  useEffect(() => {
    window.location.replace(
      "https://www.shubhraranjan.com/courses/gs-courses/gs-foundation-online-course"
      // "https://instituteforhumanities.com/courses/123"
    );
  }, []);

  return null;
};

const GSFoundationClassroomCourseRedirect = () => {
  useEffect(() => {
    window.location.replace(
      "https://www.shubhraranjan.com/courses/gs-courses/gs-foundation-classroom-course"
    );
  }, []);

  return null;
};

const SociologyOptionalClassroomCourseRedirect = () => {
  useEffect(() => {
    window.location.replace(
      "https://www.shubhraranjan.com/courses/sociology-courses/sociology-optional-classroom-course"
    );
  }, []);

  return null;
};

const PSIROptionalClassroomCourseRedirect = () => {
  useEffect(() => {
    window.location.replace(
      "https://www.shubhraranjan.com/courses/psir-courses/psir-optional-classroom-course"
    );
  }, []);

  return null;
};

const PoliticalScienceInternationalRelationsTabletCourseRedirect = () => {
  useEffect(() => {
    window.location.replace(
      "https://www.shubhraranjan.com/psir-mission1250-upsc-online-course"
    );
  }, []);

  return null;
};

const PsirOptionalClassroomCourseRedirect = () => {
  useEffect(() => {
    window.location.replace(
      "https://www.shubhraranjan.com/psir-mission1250-upsc-classroom-course"
    );
  }, []);

  return null;
};

const IASInstitutePuneRedirect = () => {
  useEffect(() => {
    window.location.replace(
      "https://www.shubhraranjan.com/IAS_Institute_Pune"
    );
  }, []);
}

const PSIRWritingMentorShip = () => {
  useEffect(() => {
    window.location.replace(
      "https://www.shubhraranjan.com/courses/psir-courses/psir-answer-writing-module"
    );
  }, []);

  return null;
};
export { PSIRRedirect, GSFoundationOnlineCourseRedirect, GSFoundationClassroomCourseRedirect, SociologyOptionalClassroomCourseRedirect, PSIROptionalClassroomCourseRedirect, PoliticalScienceInternationalRelationsTabletCourseRedirect, PsirOptionalClassroomCourseRedirect, IASInstitutePuneRedirect, PSIRWritingMentorShip };
